module.exports = __webpack_public_path__ + "static/media/nophoto.f7f18321.jpg";